
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"21","viewBox":"0 0 13 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0.771599 12.0185C-0.159624 11.2203 -0.159624 9.77968 0.771599 8.98149L9.69842 1.32993C10.9958 0.217916 13 1.13973 13 2.84844L13 18.1516C13 19.8603 10.9958 20.7821 9.69842 19.6701L0.771599 12.0185Z","fill":"currentColor"}})])
          )
        }
      }
    